const GRID_CALLBACK_TYPES = {
	MASK_UPDATE: "mask-update",
	SEQUENCE_START: "sequence-start",
	SEQUENCE_COMPLETED: "sequence-completed",
};

export default GRID_CALLBACK_TYPES;
